export const dbsKeys = {
  provinces: "dbs.provinces.v2",
  deals: "dbs.deals.v1",
  businesses: "dbs.businesses.v1",
  ads: "dbs.ads.v1",
  bookings: "dbs.bookings.v1",
  users: "dbs.users.v1",
  favorites: "dbs.favorites.v1",
  alerts: "dbs.alerts.v1",
  session: "dbs.session.v1",
  payments: "dbs.payments.v1",
  subscriptions: "dbs.subscriptions.v1",
  supportRequests: "dbs.supportRequests.v1",
  paymentPlans: "dbs.paymentPlans.v1",
  travelFlights: "dbs.travelFlights.v1",
  travelBuses: "dbs.travelBuses.v1",
  travelHotels: "dbs.travelHotels.v1",
  travelTours: "dbs.travelTours.v1",
  travelCars: "dbs.travelCars.v1",
  appConfig: "dbs.appConfig.v1",
  alerts: "dbs.alerts.v2",
  favorites: "dbs.userFavorites.v1",
};
